/** Check if two JavaScript sets are equal */
export function setsEq<T>(a: Set<T>, b: Set<T>): boolean {
  return a.size === b.size && a.symmetricDifference(b).size === 0
}
